// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__n8vwT","active":"NavigationItem_active__2FR6X"};